module.exports = __webpack_public_path__ + "static/media/stop-words-guide.d3c156b0.png";